/* WAYAK landing v3 — conversion event tracking.
   Uses the global posthog-js singleton initialized in src/app/providers.tsx.
   Every event carries `source: landing_v3` + the current path, so funnels can
   be split by page (home vs. /use-cases/<industry>) and by CTA location. */

import posthog from "posthog-js";

export type LandingEvent =
  | "landing_signup_click" // any "start free trial" action; has_email=true when the inline form was submitted with an email
  | "landing_demo_click" // "book a demo" CTAs
  | "landing_contact_click" // "talk to us" / contact CTAs
  | "landing_login_click"
  | "landing_use_case_click" // industry card on the home page
  | "landing_services_click" // cross-link to the /services page
  | "landing_docs_click";

export interface LandingEventProps {
  /** Where on the page the CTA lives: topbar | hero | final_cta | industry_topbar | industry_hero | footer | use_cases_grid | automations_library */
  location?: string;
  /** Industry slug when relevant. */
  industry?: string;
  /** Inline signup form: was an email entered? */
  has_email?: boolean;
  [key: string]: unknown;
}

export function trackLanding(event: LandingEvent, props: LandingEventProps = {}) {
  if (typeof window === "undefined") return;
  try {
    posthog.capture(event, {
      source: "landing_v3",
      path: window.location.pathname,
      ...props,
    });
  } catch {
    // analytics must never break the page
  }
}
